<ng-container
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="context"
></ng-container>
